import Style from "@client/controls/HTML/Style/component";
import { getStyleSheetColor, STYLE_SHEET_IDS } from "@client/lib/styleSheet";
import * as clientStateSelectors from "@client/selectors/state";
import { type CompositeSettings, ScreenType } from "@client/types";
import React from "react";
import { useSelector } from "react-redux";
import { getStyleSheetLinkClassName } from "../lib";
import { TEXT_TAGS } from "./Color";

type Props = {
  id: string;
  screen: ScreenType;
  setting: CompositeSettings.Link;
};
export default (props: Props) => {
  const styleSheetSettings = useSelector(clientStateSelectors.styleSheetDataSettingsSelector);
  const localStyleSheetSettings = useSelector(clientStateSelectors.styleSheetDataLocalSelector);

  const color = React.useMemo(
    () => getStyleSheetColor(styleSheetSettings, localStyleSheetSettings, props.setting.color, props.screen, "primary"),
    [styleSheetSettings, localStyleSheetSettings, props.setting.color, props.screen]
  );

  const hoverColor = React.useMemo(
    () =>
      getStyleSheetColor(
        styleSheetSettings,
        localStyleSheetSettings,
        props.setting.hover?.color,
        props.screen,
        "primary"
      ),
    [styleSheetSettings, localStyleSheetSettings, props.setting.hover?.color, props.screen]
  );

  const css = React.useMemo(
    () =>
      TEXT_TAGS.map((x) => {
        const baseSelector = `.${getStyleSheetLinkClassName(x, props.id)} ${x === "text" ? "" : x}`;

        let css = `${baseSelector} a {
          color: ${color};
          text-decoration-line: ${props.setting.decoration ?? "none"};
        }
        ${baseSelector} a:hover {
          color: ${hoverColor};
          text-decoration-line: ${props.setting.hover?.decoration ?? "none"};
        }`;

        if (props.id === STYLE_SHEET_IDS.defaults.link) {
          css += `\n.wsc_viewport ${x === "text" ? "" : x} a {
            color: ${color};
            text-decoration-line: ${props.setting.decoration ?? "none"};
          }
          .wsc_viewport ${x === "text" ? "" : x} a:hover {
            color: ${hoverColor};
            text-decoration-line: ${props.setting.hover?.decoration ?? "none"};
          }`;
        }

        return css;
      }).join("\n"),
    [props.id, props.setting, color, hoverColor]
  );

  // return <pre>{JSON.stringify(props.setting)}</pre>;

  return <Style css={css} />;
};
